import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PagePayload } from '../shared/models/common.model';
import { Page } from '../shared/models/page';
import { handleHttpParams } from '../shared/utils/common';
import { Category } from './models';

@Injectable({
    providedIn: 'root',
})
export class CategoriesService {
    http = inject(HttpClient);

    constructor() {}

    getCategories(payload: PagePayload): Observable<Page<Category>> {
        const httpParams = handleHttpParams(payload);
        return this.http.get<Page<Category>>('categories', { params: httpParams });
    }

    getPinnedCategories(): Observable<Page<Category>> {
        const params = new HttpParams().set('isPinned', 'true').set('limit', '100').set('offset', '0');
        return this.http.get<Page<Category>>('categories', { params });
    }

    updateCategory(id: number, body: Partial<Category>): Observable<Category> {
        return this.http.put<Category>(`categories/${id}`, body);
    }

    createCategory(body: Partial<Category>): Observable<Category> {
        return this.http.post<Category>(`categories`, body);
    }

    deleteCategory(id: number): Observable<unknown> {
        return this.http.delete<unknown>(`categories/${id}`);
    }
}
